"use strict";
// Devise selon la langue choisie (sélecteur de langue de l'en-tête).
// 1. Quand la devise est acceptée par Shopify (marchés), le sélecteur bascule le pays : Shopify affiche alors les vrais prix
//    dans cette devise ; ici on convertit seulement les montants écrits « en dur » dans le thème (data-eur).
// 2. Quand Shopify ne gère pas la devise au paiement (rand, yuan, livre turque, rouble…), on convertit tout l'affichage
//    au taux du jour de la BCE (api.frankfurter.app), avec « ≈ », et on rappelle que le paiement se fait en euros.
(function () {
  const DEVISE = { fr: "EUR", de: "EUR", es: "EUR", it: "EUR", nl: "EUR", pt: "EUR", en: "GBP", pl: "PLN", ar: "AED",
    ja: "JPY", ko: "KRW", "zh-CN": "CNY", tr: "TRY", af: "ZAR", ru: "RUB" };
  // devise du PAYS (marché Shopify) : la langue ne sert qu'en secours (pays inconnu)
  const PAYS = { AD: "EUR", AT: "EUR", BE: "EUR", CY: "EUR", DE: "EUR", EE: "EUR", ES: "EUR", FI: "EUR", FR: "EUR", GR: "EUR", HR: "EUR",
    IE: "EUR", IT: "EUR", LT: "EUR", LU: "EUR", LV: "EUR", MC: "EUR", MT: "EUR", NL: "EUR", PT: "EUR", SI: "EUR", SK: "EUR", SM: "EUR", VA: "EUR",
    GB: "GBP", PL: "PLN", AE: "AED", JP: "JPY", KR: "KRW", CN: "CNY", TR: "TRY", ZA: "ZAR", RU: "RUB", CH: "CHF", US: "USD", CA: "CAD",
    SE: "SEK", NO: "NOK", DK: "DKK", CZ: "CZK", HU: "HUF", RO: "RON", BG: "BGN", AU: "AUD", NZ: "NZD", BR: "BRL", MX: "MXN", IN: "INR",
    SG: "SGD", HK: "HKD", TH: "THB", IL: "ILS", SA: "SAR" };
  const m = document.cookie.match(/(?:^|; )googtrans=\/fr\/([^;]+)/);
  const lang = m ? decodeURIComponent(m[1]) : "fr";
  const pays = (window.Shopify && window.Shopify.country) || "";
  const voulue = PAYS[pays] || DEVISE[lang] || "EUR";
  const shop = (window.Shopify && window.Shopify.currency) || { active: "EUR", rate: "1" };
  const active = shop.active || "EUR", tauxShop = parseFloat(shop.rate) || 1;   // tauxShop : 1 € → devise active
  const locale = { fr: "fr-FR", en: "en-GB", ar: "ar-AE", "zh-CN": "zh-CN", af: "af-ZA" }[lang] || lang;
  const sansDecimales = ["JPY", "KRW", "HUF"];
  // narrowSymbol : « £ » et non « £GB » (la locale fr-FR écrit le symbole livre ainsi)
  const fmt = (v, c) => new Intl.NumberFormat(locale, { style: "currency", currency: c, currencyDisplay: "narrowSymbol",
    minimumFractionDigits: sansDecimales.includes(c) ? 0 : 2, maximumFractionDigits: sansDecimales.includes(c) ? 0 : 2 }).format(v);
  const symbole = (c) => (new Intl.NumberFormat(locale, { style: "currency", currency: c }).formatToParts(0).find((p) => p.type === "currency") || {}).value || c;

  // ligne « soit X € (en euros) » sous chaque prix, écrite dans la langue choisie : data-eur-cents = prix de référence en centimes (snippet luxe-eur)
  // la ligne reste cachée quand le visiteur voit déjà des euros, ou quand le produit n'a pas de prix de référence
  const TEXTE_EUR = { fr: "soit {x} (en euros)", en: "i.e. {x} in euros", de: "entspricht {x} (in Euro)", es: "equivale a {x} (en euros)",
    it: "equivale a {x} (in euro)", nl: "gelijk aan {x} (in euro)", pt: "equivale a {x} (em euros)", pl: "czyli {x} (w euro)",
    ar: "أي {x} (باليورو)", ja: "ユーロ建て {x}", ko: "유로로 {x}", "zh-CN": "折合 {x}（欧元）", tr: "yani {x} (euro olarak)",
    af: "dit is {x} in euro", ru: "то есть {x} (в евро)" };
  const prixEur = () => {
    const affichee = voulue === active ? active : voulue;
    document.querySelectorAll(".prix-eur[data-eur-cents]").forEach((el) => {
      const cents = +el.dataset.eurCents;
      el.hidden = affichee === "EUR" || !cents;
      if (!el.hidden) el.textContent = (TEXTE_EUR[lang] || TEXTE_EUR.en).replace("{x}", fmt(cents / 100, "EUR"));
    });
  };
  window.LUXE_PRIX_EUR = prixEur;
  prixEur();

  // taux du jour (mis en cache 12 h dans le navigateur)
  const tauxBCE = async (c) => {
    const k = "luxe-taux-" + c;
    try { const v = JSON.parse(localStorage.getItem(k) || "null"); if (v && Date.now() - v.t < 432e5) return v.r; } catch (e) { /* stockage indisponible */ }
    // taux officiels BCE (Frankfurter) ; en secours ExchangeRate-API (qui a aussi le rouble)
    const lire = (u) => fetch(u).then((x) => x.json()).then((d) => d.rates && d.rates[c]).catch(() => null);
    const r = (await lire("https://api.frankfurter.dev/v1/latest?base=EUR&symbols=" + c)) || (await lire("https://open.er-api.com/v6/latest/EUR"));
    if (r) try { localStorage.setItem(k, JSON.stringify({ t: Date.now(), r })); } catch (e) { /* tant pis */ }
    return r;
  };

  // nombres comme « 19,99 € », « 1 234,50 € » ou « €19.99 » dans le texte de la page
  const RE = /(?:€\s?)?(\d{1,3}(?:[\s  .]\d{3})*(?:,\d{2})|\d+(?:,\d{2})?)\s?€|€\s?(\d+(?:[.,]\d{2})?)/g;
  const nombre = (s) => parseFloat(String(s).replace(/[\s  .]/g, "").replace(",", "."));

  const appliquer = (taux, approx) => {
    const pre = approx ? "≈ " : "";
    // montants écrits en euros dans le thème
    document.querySelectorAll("[data-eur]").forEach((el) => { el.textContent = pre + fmt(+el.dataset.eur * taux, voulue); el.classList.add("notranslate"); });
    // compteurs animés (prix de l'accueil)
    document.querySelectorAll("[data-eur-count]").forEach((el) => {
      // devise gérée par Shopify : on prend le vrai prix (arrondi par Shopify) ; sinon conversion au taux du jour
      const fin = !approx && el.dataset.prixReel ? +el.dataset.prixReel : +el.dataset.eurCount * taux;
      el.dataset.count = fin.toFixed(2);
      // point de départ : un chiffre rond au-dessus (≈ 5 fois le prix), comme 99,99 € pour 19,99 € → 1 999,99 R, 19 999 ¥…
      const cinq = fin * (+el.dataset.eurFrom / +el.dataset.eurCount), mag = Math.pow(10, Math.floor(Math.log10(cinq)));
      el.dataset.from = (Math.ceil(cinq / mag) * mag - (sansDecimales.includes(voulue) ? 1 : 0.01)).toFixed(sansDecimales.includes(voulue) ? 0 : 2);
      el.dataset.devise = voulue; el.dataset.locale = locale; el.dataset.approx = approx ? "1" : "";
      el.dataset.dec = sansDecimales.includes(voulue) ? "0" : "2";
      el.textContent = pre + fmt(+(el.closest(".done") ? el.dataset.count : el.dataset.from), voulue);
      const s = el.parentNode.querySelector("[data-suffixe]"); if (s) s.style.display = "none";
    });
    if (!approx) return;
    // prix affichés par Shopify (restés dans la devise active) → convertis à l'affichage
    const conv = (noeud) => {
      // on ignore nos propres montants (sinon l'observateur les reconvertit sans fin → page figée) et les montants déjà gérés
      const w = document.createTreeWalker(noeud, NodeFilter.SHOW_TEXT, { acceptNode: (n) =>
        /SCRIPT|STYLE|TEXTAREA|INPUT/.test(n.parentNode.nodeName) || !/€/.test(n.nodeValue) || n.parentNode.closest(".prix-eur, .notranslate, [data-eur-count]") ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT });
      const l = []; while (w.nextNode()) l.push(w.currentNode);
      l.forEach((n) => {
        // chaque montant converti est mis dans un <span translate="no"> pour que Google Traduction n'y touche pas
        const frag = document.createDocumentFragment(); let i = 0;
        n.nodeValue.replace(RE, (t, a, b, pos) => {
          frag.appendChild(document.createTextNode(n.nodeValue.slice(i, pos)));
          const sp = document.createElement("span"); sp.className = "notranslate"; sp.setAttribute("translate", "no");
          sp.textContent = pre + fmt(nombre(a || b) / tauxShop * taux, voulue); frag.appendChild(sp); i = pos + t.length;
        });
        frag.appendChild(document.createTextNode(n.nodeValue.slice(i)));
        n.parentNode.replaceChild(frag, n);
      });
    };
    conv(document.body);
    new MutationObserver((ms) => ms.forEach((x) => { if (x.type === "characterData") conv(x.target.parentNode || document.body); else x.addedNodes.forEach((n) => n.nodeType === 1 ? conv(n) : n.nodeType === 3 && conv(n.parentNode)); }))
      .observe(document.body, { subtree: true, childList: true, characterData: true });
    // rappel : le paiement se fait en euros
    const note = document.createElement("p");
    note.className = "devise-note";
    note.textContent = "Prix indicatifs en " + voulue + " — le paiement se fait en euros (" + active + ").";
    document.querySelectorAll(".sum, .p-trust").forEach((el) => el.after(note.cloneNode(true)));
  };

  window.LUXE_DEVISE = { lang, voulue, active };
  let pret; window.LUXE_DEVISE_PRET = new Promise((r) => { pret = r; setTimeout(r, 3000); }); // au pire, le compteur part au bout de 3 s
  if (voulue === active) { if (active !== "EUR") appliquer(tauxShop, false); pret(); return; }
  tauxBCE(voulue).then((r) => { if (r) appliquer(r, true); }).catch(() => {}).finally(pret);
})();
